import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-calendar\"><path d=\"M21.2 3.8H17V2.2a.2.2 0 00-.2-.2h-1.4a.2.2 0 00-.2.2v1.6H8.8V2.2a.2.2 0 00-.2-.2H7.2a.2.2 0 00-.2.2v1.6H2.8a.8.8 0 00-.8.8v16.6a.8.8 0 00.8.8h18.4a.8.8 0 00.8-.8V4.6a.8.8 0 00-.8-.8zm-1 16.4H3.8v-9.5h16.4v9.5zM3.8 9V5.6H7v1.2c0 .11.09.2.2.2h1.4a.2.2 0 00.2-.2V5.6h6.4v1.2c0 .11.09.2.2.2h1.4a.2.2 0 00.2-.2V5.6h3.2V9H3.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol